import React from "react";
import styles from "../document/document.module.css";
import backgroundImage from "./../../assets/16.09.2022-2-1-2.jpg";

export const Procedura = () => {
  const documentList = [];

  const backgroundStyle = {
    backgroundSize: "cover",
  };

  return (
    <div style={backgroundStyle}>
      <div className={styles.documentsPage}>
        <header className={styles.header}>
          <h1>
            სწავლა-სწავლების საგანმანათლებლო პრინციპები, პროგრამები,
            ჩარიცხვის პროცედურები და მისანიჭებელი კვალიფიკაცია
          </h1>
        </header>
        <div className={styles.documentsContainer}>
         <section  style={{marginTop: "20px", marginBottom: "20px"}}>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა,
              თავდაპირველი სახელით „წმინდა ანდრია პირველწოდებულის სახელობის
              გიმნაზია“ დაარსდა 1991 წლის 15 ოქტომბერს საქართველოს საპატრიარქოს
              მიერ; მისი უშუალო დამაარსებელი გახლავთ ბათუმისა და ლაზეთის
              მიტროპოლოტი დიმიტრი (იმჟამად დეკანოზი დავით შიოლაშვილი).
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              სასწავლებლის მიზანი იყო მოსწავლეებისათვის შეექმნა საბჭოთა
              იდეოლოგიისაგან თავისუფალი საგანმანათლებლო სივრცე, რათა მათ
              შეეძინათ ქრისტიანულ ცნობიერებაზე დაფუძნებული დემოკრატიული
              საზოგადოების მოქალაქეებისათვის საჭირო უნარ–ჩვევები; აღზრდილიყვნენ
              ეროვნულ და მსოფლიო ფასეულობებზე, ყოფილიყვნენ ღია და გახსნილები
              საზოგადოებისათვის, დამოუკიდებელი, შემოქმედებითი პიროვნებები.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              თავდაპირველად სასწავლებელში გაიხსნა ოთხი კლასი 80 მოსწავლეზე.
              ამჟამად აქ სწავლობს 1206 (2025 წლის 1 სექტემბრის მონაცემებით)
              მოსწავლე სწავლების სამივე საფეხურზე; მოგვიანებით სახელმწიფო
              რეესტრში გიმნაზია გაფორმდა, როგორც შპს “წმინდა ანდრია
              პირველწოდებული სახელობის სკოლა“, ხოლო 2019 წლიდან, როგორც ა(ა)იპ
              „ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა“.
              დამფუძნებელი - საქართველოს საპატრიარქო, ბათუმისა და ლაზეთის
              ეპარქია.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              სკოლა საგანმანათლებლო საქმიანობას ახორციელებს დაწყებით, საბაზო და
              საშუალო საფეხურზე ქართულ ენაზე;
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              სკოლაში სწავლა-სწავლების საგანმანათლებლო პრინციპები
              განსაზღვრულია ე-სგ-ის მიხედვით და შიგა სამართლებრივი დოკუმენტებით.
            </p>
          </section>
         <section  style={{marginTop: "20px", marginBottom: "20px"}}>
           <h2 style={{marginTop: "20px", marginBottom: "20px"}}>სწავლების მისია და მიზნები</h2>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              საგანმანათლებლო გეგმის მისიაა მოსწავლის ჰოლისტური (შემეცნებითი,
              ფიზიკური, ფსიქო-სოციალური) განვითარება. ამისათვის:
            </p>
           <h3 style={{marginTop: "20px", marginBottom: "20px"}}>დაწყებითი საფეხური</h3>
            <ul>
              <li>
                ფუნდამენტური აკადემიური უნარების - წიგნიერებისა და რაოდენობრივი
                წიგნიერების განვითარების ხელშეწყობა;
              </li>
              <li>
                სასკოლო გარემოსა და სწავლის მიმართ დადებითი დამოკიდებულების,
                პოზიტიური აკადემიური თვითკონცეფციის ჩამოყალიბება და მოსწავლის
                მომზადება საბაზო საფეხურისთვის;
              </li>
            </ul>
           <h3 style={{marginTop: "20px", marginBottom: "20px"}}>საბაზო საფეხური</h3>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              სკოლამ უნდა უზრუნველყოს საგანთა სწავლა-სწავლების საფუძველზე მყარი,
              დინამიკური და ფუნქციური ცოდნის კონსტრუქცია, მოსწავლის ინტერესებისა
              და მიდრეკილებების გამოვლენა და მხარდაჭერა, დამოუკიდებელი სწავლის
              უნარისა და შრომისუნარიანობის განვითარება, აქტიური მოქალაქის
              ფორმირების ხელშეწყობა და საფუძვლების შექმნა განათლების მომდევნო
              საფეხურზე (აკადემიური, პროფესიული) სწავლის გაგრძელებისთვის ან
              პროფესიული საქმიანობისთვის;
            </p>
           <h3 style={{marginTop: "20px", marginBottom: "20px"}}>საშუალო საფეხური</h3>
            <ul>
              <li>
                სისტემური აკადემიური და/ან პროფესიული ცოდნის კონსტრუქტირება;
              </li>
              <li>
                მოსწავლის მიერ საკუთარი პიროვნული发展的 დაგეგმვისა და
                აკადემიური/პროფესიული ორიენტაციის მხარდაჭერა.
              </li>
            </ul>
          </section>
         <section  style={{marginTop: "20px", marginBottom: "20px"}}>
           <h2 style={{marginTop: "20px", marginBottom: "20px"}}>ეროვნული სასწავლო გეგმის მიზნები</h2>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>ეროვნული სასწავლო გეგმის მიზანია, მოსწავლემ შეძლოს:</p>
            <ol>
              <li>
                ინფორმაციის გააზრება საკუთარ გამოცდილებაზე დაყრდნობით;
                აზრის/იდეის ჩამოყალიბება მიზნებისა და აუდიტორიის
                გათვალისწინებით;
              </li>
              <li>
                კულტურათა თავისებურებების გათვალისწინება ინფორმაციის აღქმისა და
                შეფასებისას;
              </li>
              <li>
                კანონზომიერებების აღმოჩენა და მოდელირება ახალ სიტუაციასთან
                მიმართებით; სასწავლო მასალის მეცნიერულ კონტექსტში გააზრება;
              </li>
              <li>
                სასწავლო ამოცანებისა და ცხოვრებისეული პრობლემების წარმატებით
                გადაჭრა მრავალფეროვანი სტრატეგიებისა და მიდგომების საშუალებებით;
              </li>
              <li>
                უფრო ღრმა რეფლექსია — საკუთარი მსოფლმხედველობის რეფლექსია
                შეძენილი ცოდნის საფუძველზე;
              </li>
              <li>
                შეძენილი ცოდნის გამოყენება საკუთარი, საზოგადოებრივი თუ
                სახელმწიფოებრივი მიზნებისა და საჭიროებებისთვის.
              </li>
            </ol>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              ეროვნული სასწავლო გეგმის მიზნებზე დაფუძნებით განისაზღვრება
              გათვალისწინებული საგნობრივი ჯგუფის და სწავლების
              შედეგები/კომპეტენციები, რომლებიც მოსწავლემ უნდა განივითაროს
              თითოეულ საგანში (იხ. ესგ. მე-10 მუხლი).
            </p>
          </section>
         <section  style={{marginTop: "20px", marginBottom: "20px"}}>
           <h2 style={{marginTop: "20px", marginBottom: "20px"}}>მოსწავლეთა მიღება და ჩარიცხვა</h2>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>სკოლაში მოსწავლეთა მიღება მიმდინარეობს შემდეგი წესით:</p>
           <h3 style={{marginTop: "20px", marginBottom: "20px"}}>პირველი კლასი</h3>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              სკოლის პირველ კლასში მიიღებიან აღსაზრდელები, რომელთა სასკოლო ასაკს
              განსაზღვრავს საქართველოს განათლებისა და მეცნიერების სამინისტრო.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              კლასში მოსწავლეთა ჩარიცხვა ხდება მშობლის (ან კანონიერი
              წარმომადგენლის) განცხადების საფუძველზე; განცხადებასთან ერთად
              მშობელმა (კანონიერმა წარმომადგენელმა) უნდა წარმოადგინოს:
            </p>
            <ul>
              <li>განცხვება სკოლის დირექტორის სახელზე;</li>
              <li>მოსწავლის ორი ფოტოსურათი (3x4);</li>
              <li>მოსწავლის ფოტოსურათი დისკზე;</li>
              <li>დაბადების მოწმობის სანოტაროდ დამოწმებული ასლი;</li>
              <li>
                სამოქალაქო რეესტრის სააგენტოს ან მისი ტერიტორიული სამსახურის
                მიერ გაცემული დოკუმენტი, რომლითაც დასტურდება საქართველოს
                მოქალაქეობის, საქართველოში ბინადრობის ნებართვის, ან ბინადრობის
                მოწმობის მქონე მოსწავლისათვის პირადი ნომრის მინიჭება;
              </li>
              <li>მშობლების პირადობის მოწმობების ასლები;</li>
              <li>ჯანმრთელობის ცნობა.</li>
            </ul>
            <p className="note">
              სსსმ (სასწავლო-სწავლების სპეციალური მომენტები?) მოსწავლის
              შემოსვლის/გადმოსვლის შემთხვევაში შესაბამისი ჯანმრთელობის ცნობა.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              კლასში მოსწავლეთა მაქსიმალური რაოდენობა არ უნდა აღემატებოდეს 25-ს.
            </p>
           <h3 style={{marginTop: "20px", marginBottom: "20px"}}>II–XII კლასებში მობილობა</h3>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              II–X კლასებში, მოსწავლეთა მობილობა ხდება საქართველოს განათლებისა
              და მეცნიერების მინისტრის 2012 წლის 19 სექტემბრის N193/ნ ბრძანების,
              ზოგადსაგანმანათლებლო დაწესებულებაში მოსწავლეთა მობილობის წესის
              შესაბამისად.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              II–X კლასებში ჩასარიცხად მოსწავლის კანონიერმა წარმომადგენელმა უნდა
              მიმართოს სკოლას და წარადგინოს შემდეგი დოკუმენტაცია:
            </p>
            <ul>
              <li>
                სრულწლოვანი მოსწავლის, ხოლო არასრულწლოვანი მოსწავლის კანონიერი
                წარმომადგენლის განცხადება, რომელიც უნდა შეიცავდეს საცხოვრებელი
                ადგილისა და ტელეფონის ნომრის ინფორმაციას და უნდა აკმაყოფილებდეს
                საქართველოს ზოგადი ადმინისტრაციული კოდექსის 78-ე მუხლით დადგენილ
                სხვა მოთხოვნებს;
              </li>
              <li>
                არასრულწლოვანი მოსწავლის კანონიერი წარმომადგენლის პირადობის
                დამადასტურებელი მოწმობის ასლი და საქართველოში ბინადრობის
                დამადასტურებელი დოკუმენტის ასლი (ასეთის არსებობის შემთხვევაში).
                დოკუმენტების უცხოურ ენაზე წარდგენის შემთხვევაში, მათ უნდა
                დაერთოს საქართველოს კანონმდებლობით დადგენილი წესით შესრულებული
                თარგმანი ქართულ ენაზე.
              </li>
            </ul>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              ზოგადსაგანმანათლებლო დაწესებულება საშუალო საფეხურზე (XI-XII
              კლასები) ჩარიცხვის მსურველ პირებს და მათ კანონიერ წარმომადგენლებს
              განუმარტავს, რომ:
            </p>
            <ul>
              <li>
                საშუალო საფეხურზე ჩარიცხვისთვის აუცილებელია მოსწავლეს ჰქონდეს
                საბაზო განათლების დამადასტურებელი ატესტატი. წინააღმდეგ
                შემთხვევაში, მისი ჩარიცხვა, მიუხედავად ასაკისა, მოხდება მაქსიმუმ
                IX კლასში;
              </li>
              <li>
                თუ მოსწავლეს არ აქვს დაძლეული საბაზო საფეხური, მოსწავლე
                შესაძლებელია ჩაირიცხოს მულტიგუნდის (მულტიდისციპლინური გუნდის)
                დასკვნის საფუძველზე;
              </li>
            </ul>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              ზოგადსაგანმანათლებლო დაწესებულება უფლებამოსილია, მობილობის
              მსურველის ჩარიცხვის შემდგომ, გასაუბრების ან გამოცდის საფუძველზე,
              დაადგინოს მოსწავლის ცოდნისა და უნარების ცალკეული კლასის/კლასების
              ეროვნული სასწავლო გეგმით დადგენილი მიღწევის დონესთან თავსებადობა,
              ცალკეულ საგანში/საგნებში მოსწავლესთან ინდივიდუალური მუშაობის
              საჭიროების განსაზღვრის მიზნით.
            </p>
          </section>
         <section  style={{marginTop: "20px", marginBottom: "20px"}}>
           <h2 style={{marginTop: "20px", marginBottom: "20px"}}>უცხოეთში მიღებული განათლების აღიარება და ჩარიცხვა</h2>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              ზოგადსაგანმანათლებლო დაწესებულება, უცხო ქვეყანაში მიღებული
              განათლების მქონე პირის სკოლაში ჩარიცხვის მსურველ მოსწავლის
              კანონიერ წარმომადგენელს, მას შემდეგ რაც მიიღებს განაცხადს და
              დოკუმენტაციას, განუმარტავს, რომ მათ უნდა მიმართონ სსიპ განათლების
              ხარისხის განვითარების ეროვნულ ცენტრს, რომელიც შეისწავლის მოსწავლის
              საგანმანათლებლო ისტორიას და დაადგენს საქართველოს ზოგადი განათლების
              სისტემასთან შესაბამისობას.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              პროცესის დასრულებამდე, დაინტერესებული პირი ზოგადსაგანმანათლებლო
              დაწესებულებაში წერს განცხადებას, რომ მოსწავლე დაესწროს საგაკვეთილო
              პროცესს. ხოლო აღიარების შემდეგ იწერება განცხადება ჩარიცხვის
              თაობაზე. აღიარების საფუძველზე განისაზღვრება, თუ რომელ კლასში
              ჩაირიცხება მოსწავლე და რა პირობებით.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              უცხოეთში მიღებული განათლების აღიარების შემთხვევაში, პირის ჩარიცხვა
              სკოლაში ხორციელდება „საქართველოში გაცემული საგანმანათლებლო
              დოკუმენტების ნამდვილობის დადასტურებისა და უცხოეთში მიღებული
              განათლების აღიარების წესისა და საფასურების დამტკიცების შესახებ“
              საქართველოს განათლებისა და მეცნიერების მინისტრის 2010 წლის პირველი
              ოქტომბრის №98/ნ ბრძანების შესაბამისად.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              აღიარების/აღიარებაზე უარის თქმის დოკუმენტში მითითებული კლასის
              შესაბამისად, ან თუ არ ირკვევა, ასაკის შესაბამის ან მისი თანხმობის
              შემთხვევაში — უფრო დაბალ კლასში.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              სპეციალიზირებული სკოლებიდან სპეციალური საგანმანათლებლო საჭიროების
              მქონე მოსწავლის დაწყებით და საბაზო საფეხურის ცალკეულ კლასში
              ჩასარიცხად დამატებით საჭიროა საქართველოს განათლებისა და
              მეცნიერების სამინისტროში არსებული შესაბამისი სპეციალისტებისაგან
              შემდგარი ინკლუზიური განათლების მულტიდისციპლინური გუნდის
              გადაწყვეტილება.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              მოსწავლის კლასიდან კლასში გადაყვანა ხდება დირექტორის ბრძანების
              საფუძველზე, საქართველოს კანონმდებლობით დადგენილი წესით. სკოლა
              უფლებამოსილია მობილობის მსურველის ჩარიცხვამდე, გასაუბრების ან/და
              გამოცდის საფუძველზე დაადგინოს მობილობის მსურველის ცოდნისა და
              უნარების დონე შემდგომი ინდივიდუალური მუშაობის მიზნით.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              სკოლაში მოსწავლის ჩარიცხვისას მოსწავლის მშობელთან (კანონიერ
              წარმომადგენელთან) ფორმდება ხელშეკრულება, რომელშიც ასახულია სკოლისა
              და მშობლის ურთიერთვალდებულებები და პასუხისმგებლობები.
            </p>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              მოსწავლე, რომელიც კანონმდებლობით დადგენილი წესით დაძლევს ეროვნული
              სასწავლო გეგმით გათვალისწინებულ დონეს, მიიღებს განათლების
              დამადასტურებელ შესაბამის დოკუმენტს:
            </p>
            <ul>
              <li>
                პური სრული ზოგადი განათლების დამადასტურებელი დოკუმენტი – სრული
                ზოგადი განათლების ატესტატი;
              </li>
              <li>
                საბაზო ზოგადი განათლების დამადასტურებელი დოკუმენტი – საბაზო
                ზოგადი განათლების ატესტატი;
              </li>
            </ul>
            <p style={{marginTop: "20px", marginBottom: "20px"}}>
              ზოგადი განათლების საბაზო საფეხურისთვის განსაზღვრული სწავლის
              შედეგები შეესაბამება ეროვნული კვალიფიკაციების ჩარჩოს მე-2
              დონისათვის განსაზღვრულ განზოგადებულ სწავლის შედეგებს, ხოლო ზოგადი
              განათლების საშუალო საფეხურის/სრული ზოგადი განათლების სწავლის
              შედეგები − ეროვნული კვალიფიკაციების ჩარჩოს მე-4 დონისათვის
              განსაზღვრულ განზოგადებულ სწავლის შედეგებს.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
